import { SegmentEvents } from '../interface/segment-events';

export const SegmentEventsConstants: SegmentEvents = {
	bulk_add_carrier: 'user.bulk_add_carrier',
	carrier_added: 'user.add_carrier',
	clicked_book_carrier: 'user.clicked_book_carrier',
	clicked_book_now: 'user.clicked_book_now',
	contact_requested: 'user.clicked_contact_info',
	created_quote: 'user.created_quote',
	login_failed: 'user.login_failed',
	logged_in: 'user.logged_in',
	logged_out: 'user.logged_out',
	registered: 'user.registered',
	registration_failed: 'broker.registration_failed',
	reviewed_email: 'user.reviewed_email',
	save_new_carrier: 'user.save_new_carrier',
	submitted_rate_confirmation: 'user.submitted_rate_confirmation',
	truck_search: 'user.searched_trucks',
	user_submitted_booking_assistant: 'user.submitted_booking_assistant',
	user_posted_load: 'user.posted_load',
	user_submitted_carrier_feedback: 'user.submitted_carrier_feedback',
	user_selected_carrier: 'user.selected_carrier',
	user_load_not_booked: 'user.load.not.booked',
	user_registered: 'user.registered',
	user_countered_back: 'user.countered_back',
	viewed_register: 'viewed.register',
	carrier_responded_to_offer: 'carrier.responded_to_offer',
	user_verified_email: 'user.verified_email',
	user_incorrect_carrier_info: 'user.incorrect_carrier_info',
	user_viewed_full_profile: 'user.viewed_full_profile',
	user_registered_for_pricing: 'user.registered_for_pricing',
	user_clicked_lane_pricing: 'user.clicked_lane_pricing',
	user_clicked_recent_transactions: 'user.clicked_recent_transactions',
	user_filtered_search: 'user.filtered_search',
	user_capacity_search_count: 'user.received_low_capacity_matches',
	user_created_project: 'user.created_project',
	user_added_carrier_to_projects: 'user.added_carrier_to_projects',
	user_report_lane_recruiting: 'user.report_lane_recruiting',
	user_recruit_lanes: 'user.recruit_lanes',
	carrier_missing_contact_info: 'carrier.missing_contact_info',
	user_payment_processing_error: 'user.payment_processing_error',
	user_completed_setup: 'user.completed_setup',
	user_added_payment_info: 'user.added_payment_info',
	user_searched_carriers: 'user.searched_carriers',
	user_changed_subscription: 'user.changed_subscription',
	user_recruit_lanes_carrier: 'user.recruit_lanes_carrier',
	user_added_note_to_carrier: 'user.added_note_to_carrier',
	user_viewed_project: 'user.viewed_project',
	carrier_submitted_rfp: 'carrier.submitted_rfp',
	user_viewed_carriers: 'user.viewed_carriers',
	user_carrier_removed_from_project: 'user.carrier_removed_from_project',
	user_assigned_project: 'user.assigned_project',
	user_created_task: 'user.created_task',
	user_updated_tasks: 'user.updated_tasks',
	user_deleted_tasks: 'user.deleted_tasks',
	user_added_note_to_project: 'user.added_note_to_project',
	user_viewed_project_list: 'user.viewed_project_list',
	user_viewed_current_price: 'user.viewed_current_price',
	user_viewed_recent_transactions: 'user.viewed_recent_transactions',
	current_price_failed_for_search: 'current_price.failed_for_search',
	recent_transactions_failed_for_search: 'recent_transactions.failed_for_search',
	user_viewed_recent_carriers: 'user.viewed_recent_carriers',
	user_quick_searched: 'user.quick_searched',
	user_viewed_recent_transaction_details: 'user.viewed_recent_transaction_details',
	user_submitted_rate_feedback: 'user.submitted_rate_feedback',
	carrier_responded_to_rfp: 'carrier.responded_to_rfp',
	user_cancelled_subscription: 'user.cancelled_subscription',
	user_update_default_credit_card_failed: 'user.update_default_credit_card_failed',
	carrier_added_lane: 'carrier.added_lane',
	user_viewed_customers: 'user.viewed_customers',
	user_viewed_customer_profile: 'user.viewed_customer_profile',
	user_updated_default_credit_card: 'user_updated_default_credit_card',
	user_viewed_usage_report: 'user.viewed_usage_report',
	user_viewed_lanes_scorecard: 'user.viewed_lanes_scorecard',
	user_viewed_customers_scorecard: 'user.viewed_customers_scorecard',
	user_viewed_carriers_scorecard: 'user.viewed_carriers_scorecard',
	user_filtered_lanes_scorecard: 'user.filtered_lanes_scorecard',
	user_filtered_customers_scorecard: 'user.filtered_customers_scorecard',
	user_filtered_carriers_scorecard: 'user.filtered_carriers_scorecard',
	user_clicked_onboard_carrier: 'user.clicked_onboard_carrier',
	user_confirmed_onboard_carrier: 'user.confirmed_onboard_carrier',
	user_invited_user: 'user.invited_user',
	admin_invited_user: 'admin.invited_user',
	admin_added_account: 'admin.added_account',
	user_opted_out_carrier_warmup: 'user.opted_out_carrier_warmup',
	user_confirmed_carrier_warmup: 'user.confirmed_carrier_warmup',
	user_uploaded_carriers: 'user.uploaded_carriers',
	user_clicked_upload_carriers: 'user.clicked_upload_carriers',
	user_enabled_dashboard_ui: 'user.enabled_dashboard_ui',
	user_disabled_dashboard_ui: 'user.disabled_dashboard_ui',
	carrier_added_contact: 'carrier.added_contact',
	carrier_updated_contact: 'carrier.updated_contact',
	carrier_updated_lane: 'carrier.updated_lane',
	carrier_viewed_projects: 'carrier.viewed_projects',
	carrier_checked_loads: 'carrier.checked_loads',
	user_searched_projects: 'user.searched_projects',
	user_failed_to_upload_pricing_data: 'user.failed_to_upload_pricing_data',
	admin_deleted_carrier: 'admin.deleted_carrier',
	user_added_dispatch_user: 'user.add_dispatch_user',
	user_clicked_load_cancelled: 'user.clicked_load_cancelled',
	carrier_countered_from_book_now: 'carrier.countered_from_book_now',
	user_on_booking_assistant_automation_save: 'user.on_booking_assistant_automation_save',
};
